import React, { Component } from "react"
import HomeHeroSection from "./components/HomeHeroSection"

class HomeHeroSectionContainer extends Component {
  render() {
    const { images } = this.props
    return <HomeHeroSection images={images} />
  }
}

export default HomeHeroSectionContainer
